import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexto/AuthContexto";
import LayoutPrincipal from "./paginas/LayoutPrincipal";
import LoginPage from "./paginas/LoginPage";
import ClientesPage from "./paginas/ClientesPage";
import ClienteDetallePage from "./paginas/ClienteDetallePage";
import MovimientosPage from "./paginas/MovimientosPage";
import SaldosPage from "./paginas/SaldosPage";
import "./App.css";

// Mapa de pantallas. Si no hay sesión, todo lleva al login.
const Rutas = () => {
  const { user, cargando } = useAuth();

  if (cargando) return <div className="loading-screen">Cargando aplicación...</div>;

  if (!user) return <LoginPage />;

  return (
    <Routes>
      <Route element={<LayoutPrincipal />}>
        <Route path="/clientes" element={<ClientesPage />} />
        <Route path="/clientes/:id" element={<ClienteDetallePage />} />
        <Route path="/movimientos" element={<MovimientosPage />} />
        <Route path="/saldos" element={<SaldosPage />} />
        {/* Enlace viejo: quien tenga /reportes guardado sigue llegando. */}
        <Route path="/reportes" element={<Navigate to="/movimientos" replace />} />
      </Route>
      {/* Cualquier otra dirección lleva al listado de clientes. */}
      <Route path="*" element={<Navigate to="/clientes" replace />} />
    </Routes>
  );
};

const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <Rutas />
    </AuthProvider>
  </BrowserRouter>
);

export default App;
